import * as React from "react";
import * as styles from "./CalendarNameBadge.css";
import Cell from "../../Dreams/Cell/Cell";
import { ECalendarName } from "../../../../../../../motw_core/Calendar/ECalendarName";

export function CalendarNameBadge({ calendarName }: { calendarName: string }) {
    enum ECalendarBadgeColor {
        red,
        green,
        dimgray,
        black,
        darkgoldenrod,
    }

    interface ICalendarNameBadge {
        name: ECalendarName;
        color: ECalendarBadgeColor;
    }

    const calendarNameBadges: ICalendarNameBadge[] = [
        { name: ECalendarName.Outside, color: ECalendarBadgeColor.green },
        { name: ECalendarName.Timeblock, color: ECalendarBadgeColor.dimgray },
        { name: ECalendarName.Reminders, color: ECalendarBadgeColor.red },
        { name: ECalendarName.Free, color: ECalendarBadgeColor.darkgoldenrod },
    ];

    const calendarNameBadge = calendarNameBadges.find(
        (badge) => ECalendarName[badge.name] === calendarName
    );
    const calendarBadgeColor = calendarNameBadge
        ? calendarNameBadge.color
        : ECalendarBadgeColor.black;

    return (
        <span className={styles.container}>
            <Cell
                classes={[styles.calendarName]}
                style={{ background: ECalendarBadgeColor[calendarBadgeColor] }}
            >
                {calendarName}
            </Cell>
        </span>
    );
}
